<main>
  <div class="flex items-center justify-center w-screen h-screen">
    <div class="px-4 lg:py-12">
      <div class="lg:gap-4 lg:flex">
        <div class="flex flex-col items-center justify-center md:py-24 lg:py-32 text-sm">
          <a routerLink="">
            <img class="mx-auto w-64" src="assets/img/logo_preto.svg" alt="AngolaEncontra"/>
          </a>

          <div class="mb-8 my-4 text-center text-gray-500">
            <p class="mt-10">Bem-vindo(a), a sua conta foi criada, mas ainda está <span class="font-bold underline">inactiva</span>.</p>
            <p>Enviámos um PIN por SMS para o número que indicou. Clique no botão abaixo, introduza esse PIN e a conta fica activa.</p>

            <div class="mt-8">
              <app-ae-button variant="primary" label="Introduzir PIN" (buttonClick)="goToActivation()"
                        size="sm" styleClass="text-xs"></app-ae-button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</main>
